
<template>
  <div class="pw-inner">
    <input class="ob-input pw-input" :type="shown ? 'text' : 'password'" v-model="$store.state.auth[i.val]"/>
    <div class="show-hide" @click="shown = shown ? false : true">
      <img :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${shown ? 'hide' : 'show'}.png`" />
    </div>
  </div>
</template>

<script>

export default {

  data(){
    return {
      shown: false,
      pw: ''
    }
  },

  props: ['i']

}

</script>

<style>

.pw-inner {
  width: 260px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0px;
  margin-bottom: 5px;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  border-bottom: 2px solid #dce1ec;
  overflow: hidden
}

.pw-input {
  width: calc(100% - 40px);
  border: none;
}

.show-hide {
  width: 40px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(0, 153, 191);
  margin-left: -5px;
  margin-top: -5px;
  cursor: pointer;
}

.show-hide img {
  margin-top: 2px;
  height: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/landing/Password.vue